"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-5 w-16 bg-muted/40 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/40 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/40 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/40 animate-pulse rounded" />
      </div>;
  }
  const allowedLabels = ["About", "Our Process", "Portfolio", "Contact"];
  const filteredItems = menuItems.filter(item => allowedLabels.includes(item.label));
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-6">
        {filteredItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild className="relative px-0 py-2 text-sm font-medium text-black transition-colors duration-[var(--duration-medium)] hover:!bg-transparent focus:!bg-transparent after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-0 after:bg-primary after:transition-all after:duration-[var(--duration-medium)] hover:after:w-full">
              <Link to={item.href || "#"}>{item.label}</Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  const handleConversationClick = () => {
    const contactSection = document.querySelector("#contact");
    if (contactSection) {
      contactSection.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    } else {
      window.location.href = "/ContactPage";
    }
  };
  return <header className={`sticky top-0 z-50 w-full h-16 bg-background border-b border-border transition-shadow duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${scrolled ? "shadow-soft" : ""}`}>
      <div className="container mx-auto px-6 h-full flex items-center justify-between">
        <Link to="/" className="flex-shrink-0">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515703/img/brighthouse_construction_logo.png" alt="Brighthouse Construction" className="h-7" />
        </Link>

        <MenuProvider menu_id="6" className="flex-1 flex justify-center">
          <HeaderMenuConsumer />
        </MenuProvider>

        <Button onClick={handleConversationClick} className="ml-6 flex-shrink-0 bg-primary-dark text-foreground-primary hover:bg-primary-dark focus:bg-primary-dark shadow-medium hover:shadow-strong hover:-translate-y-0.5 active:translate-y-0 active:bg-primary-dark transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
          Start a Conversation
        </Button>
      </div>
    </header>;
}